import { cadastralAptSearch } from "./PropertyQueryModel.js";

import { apartmentQuery } from "~/helpers/addressSearchModel.js";

export const getQuery = (addressDto) => {
	return (addressDto.addressType === "M" ? cadastralAptSearch : apartmentQuery)(addressDto);
};
